import { useProvince } from '../hooks/useProvince';
import { useAppShellPlatform } from '../hooks/useAppShellPlatform';
import { Spinner } from '../components/Spinner';
import { ErrorMessage } from '../components/ErrorMessage';
import { MobileEconomyShell } from '../components/economy/MobileEconomyShell';
import { DesktopEconomyShell } from '../components/economy/DesktopEconomyShell';
import type { Province } from '../types/province';

/**
 * SF-164: named, fully-typed props shared by MobileEconomyShell/DesktopEconomyShell — same
 * ExploreShellProps/SciencesShellProps precedent. Unlike Explore/Sciences, this page is
 * read-only (no submit/mutation path), so it's structurally closer to Council.tsx's existing
 * pattern: useProvince() for data, a loading spinner gate, an error gate, no local draft/form
 * state at the page level.
 */
export interface EconomyShellProps {
  province: Province;
}

export function Economy() {
  const { province, isLoading, error } = useProvince();
  const platform = useAppShellPlatform();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error || !province) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <ErrorMessage message={error || 'Failed to load province'} />
        </div>
      </div>
    );
  }

  return platform === 'mobile'
    ? <MobileEconomyShell province={province} />
    : <DesktopEconomyShell province={province} />;
}
